export default __webpack_public_path__ + "static/media/fullscreen.b88680bf.svg";